module.exports = __webpack_public_path__ + "static/pcp-product-6b7df77d592133c3986a5622d3b7b203.svg";